<template>
    <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="card-icon">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'cube']" />
                    </div>
                    <h4 class="title">{{ group.intervention_type.name }}</h4>
                </md-card-header>
                <md-card-content>
                    <div>
                        <div v-for="(mths, index) in months" :key="index">
                            <div class="md-layout md-gutter mt-1">
                                <div class="md-layout-item md-size-50" v-for="month in mths" :key="month.value">
                                    <intervention-plan-edit-row
	                                    :month="month"
	                                    :groupId="group.id"
                                        :previsions="monthHasIntervention(month.value, group)"
                                        :deviceGroups="deviceGroups"
	                                    :rowErrors="errors"
	                                    @add-prevision="addInterventionPrevision"
                                        @update-prevision="updateInterventionPrevision"
                                        @deactivate-prevision="deactivateInterventionPrevision">
                                    </intervention-plan-edit-row>
                                </div>
                            </div>
                        </div>
	                    <md-divider class="my-3"></md-divider>
                        <p class="mt-2">
                            <span class="font-medium text-info">Total : </span>
                            {{ group.planning_intervention_previsions.length }} intervention(s)
                        </p>
                        <div class="md-layout md-gutter mt-2">
                            <div class="md-layout-item md-size-50">
                                <md-field class="md-invalid">
                                    <label>Commentaire</label>
                                    <md-textarea v-model="comment" name="comment" md-autogrow></md-textarea>
                                    <validation-error :errors="apiValidationErrors.comment"/>
                                </md-field>
                            </div>
	                        <div class="md-layout-item md-size-50">
		                        <div class="flex items-center justify-end space-x-4 h-full">
			                        <md-button class="md-icon-button md-raised md-success" :disabled="loading" @click="updateInterventionPlan">
				                        <font-awesome-icon class="md-icon" :icon="['fa', saving ? 'sync-alt' : 'check-circle']" :class="{ 'animate-spin': saving }"></font-awesome-icon>
				                        <span class="leading-none font-medium ml-2"> Enregistrer les modifications</span>
			                        </md-button>
			                        <md-button class="md-icon-button md-raised md-danger" :disabled="loading" @click="deactivateInterventionPlanGroup">
				                        <font-awesome-icon class="md-icon" :icon="['fa', deactivating ? 'sync-alt' : 'ban']" :class="{ 'animate-spin': deactivating }"></font-awesome-icon>
				                        <span class="leading-none font-medium ml-2"> Désactiver ce type d'intervention</span>
			                        </md-button>
		                        </div>
	                        </div>
                        </div>
                        <md-divider class="mt-3.5 mb-2.5"></md-divider>
                        <p>Dupliquer les interventions sur un autre type d'intervention</p>
                        <div class="md-layout mt-2">
                            <div class="md-layout-item md-size-35 pl-0">
                                <div class="md-multiselect">
                                    <label>Type d'intervention *</label>
                                    <multiselect v-model="interventionTypeDuplicated" placeholder="Type d'intervention"
                                                 label="name" track-by="name" :options="interventionTypes"
                                                 :option-height="104"
                                                 :show-labels="false">
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <span class="option__title">{{ props.option.name }}</span>
                                            </div>
                                        </template>
                                        <template slot="noOptions">La liste est vide</template>
                                        <template slot="noResult">Aucun élement correspondant</template>
                                    </multiselect>
                                    <validation-error :errors="apiValidationErrors.type"/>
                                </div>
                            </div>
                            <div class="md-layout-item md-size-30">
	                            <div class="flex items-center h-full">
		                            <md-button class="md-icon-button md-raised md-success" :disabled="loading" @click="duplicateInterventionPlanGroup">
			                            <font-awesome-icon class="md-icon" :icon="['fa', duplicating ? 'sync-alt' : 'copy']" :class="{ 'animate-spin': duplicating }"></font-awesome-icon>
			                            <span class="leading-none font-medium ml-2"> Dupliquer</span>
		                            </md-button>
	                            </div>
                            </div>
                        </div>
                    </div>
                </md-card-content>
            </md-card>
        </div>
    </div>
</template>

<script>
import InterventionPlanEditRow from "@/pages/Contracts/InterventionPlan/components/InterventionPlanEditRow";
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
    name: "InterventionPlanEditGroupCard",
    components: {
        InterventionPlanEditRow, ValidationError
    },
    mixins: [formMixin],
    props: {
        planningInterventionGroup: {
            type: Object,
            default() {
                return {
                    intervention_type: {},
                    planning_intervention_previsions: []
                }
            }
        },
        interventionTypes: Array,
        deviceGroups: Array
    },
    data() {
        return {
            months: [
                [
                    { value: 0, label: 'Janvier' },
                    { value: 6, label: 'Juillet' }
                ],
                [
                    { value: 1, label: 'Février' },
                    { value: 7, label: 'Août' }
                ],
                [
                    { value: 2, label: 'Mars' },
                    { value: 8, label: 'Septembre' }
                ],
                [
                    { value: 3, label: 'Avril' },
                    { value: 9, label: 'Octobre' }
                ],
                [
                    { value: 4, label: 'Mai' },
                    { value: 10, label: 'Novembre' }
                ],
                [
                    { value: 5, label: 'Juin' },
                    { value: 11, label: 'Décembre' }
                ]
            ],
            interventionTypeDuplicated: null,
            group: _.cloneDeep(this.planningInterventionGroup),
            comment: null,
            errors: [],
	        loading: false,
	        saving: false,
	        deactivating: false,
	        duplicating: false
        }
    },
    methods: {
	    async updateInterventionPlan() {
		    this.resetApiValidation()
		    this.errors = []
		    this.loading = true
		    this.saving = true
		    try {
			    await this.$store.dispatch('interventionPlans/updateInterventionGroup',
				    {
					    planning_intervention_group_id: this.group.id,
					    interventions: this.group.planning_intervention_previsions,
					    comment: this.comment
				    })
			    await this.$store.dispatch('alerts/success', 'Plan d\'intervention modifié')
		    } catch (e) {
			    this.setApiValidation(e.response.data.errors)
			    this.setPrevisionErrors(e.response.data.errors)
		    } finally {
			    this.loading = false
			    this.saving = false
		    }
	    },
	    async duplicateInterventionPlanGroup() {
		    if(this.interventionTypeDuplicated) {
				this.loading = true
			    this.duplicating = true
			    try {
				    const { data } = await this.$store.dispatch('interventionPlans/duplicateInterventionGroup', {
					    interventionGroupId: this.planningInterventionGroup.id,
					    intervention_type_id: this.interventionTypeDuplicated.id
				    })
				    await this.$store.dispatch('alerts/success', 'Duplication effectuée')

				    await this.$emit('duplicate-group', [data])
				    this.interventionTypeDuplicated = null
			    } catch (e) {}
			    finally {
				    this.loading = false
				    this.duplicating = false
			    }
		    } else {
			    await this.$store.dispatch('alerts/warning', 'Vérifier le type d\'intervention pour duplication')
		    }
	    },
	    async deactivateInterventionPlanGroup() {
		    this.$swal.fire({
			    title: "Êtes-vous sûr ?",
			    html: 'Voulez-vous supprimer ce type d\'intervention ?',
			    icon: "warning",
			    showCancelButton: true,
			    confirmButtonClass: "md-button md-success",
			    cancelButtonClass: "md-button md-warning",
			    confirmButtonText: "Désactiver",
			    cancelButtonText: "Annuler",
			    buttonsStyling: false,
		    }).then(async result => {
			    if(result.value) {
				    this.loading = true
				    this.deactivating = true
				    try {
					    await this.$store.dispatch('interventionPlans/deleteInterventionGroup', { interventionGroupId: this.group.id })
					    await this.$store.dispatch('alerts/success', 'Type d\'intervention supprimé du plan d\'intervention')

					    await this.$emit('deactivate-group', { id: this.group.id })
				    } catch (error) {}
				    finally {
					    this.loading = false
					    this.deactivating = false
				    }
			    }
		    })
	    },
        updateInterventionPrevision(prevision) {
	        const interventionPrevision = this.group.planning_intervention_previsions.find(p => p.id === prevision.id)
	        interventionPrevision.comment = prevision.comment
	        interventionPrevision.duration = prevision.duration
	        interventionPrevision.device_groups = prevision.deviceGroups
        },
	    addInterventionPrevision(prevision) {
		    this.group.planning_intervention_previsions.push(prevision)
	    },
	    deactivateInterventionPrevision(prevision) {
		    this.group.planning_intervention_previsions = this.group.planning_intervention_previsions.filter(p => p.id !== prevision.id)
	    },
        monthHasIntervention(month, group) {
            return group.planning_intervention_previsions.filter(intervention => {
                return intervention.month === month && intervention.is_active
            })
        },
        setPrevisionErrors(errors) {
            this.errors = []
            errors.map(error => {
                if(error.source.pointer.includes('interventions')) {
                    const parts = error.source.pointer.split('.')
                    const index = parts[1]
                    const intervention = this.group.planning_intervention_previsions[index]
                    this.errors.push({
                        interventionId: intervention.id,
                        detail: error.detail,
                        source: {
                            pointer: `/data/attributes/${parts[2]}`
                        }
                    })
                }
            })
        },
        goBack() {
            this.$router.back()
        }
    },
    watch: {
        planningInterventionGroup(newVal) {
            this.group = _.cloneDeep(newVal)
        }
    },
    mounted() {
        this.comment = this.planningInterventionGroup.commentable ? this.planningInterventionGroup.commentable.comment : null
    }
}
</script>

<style scoped lang="scss">
.md-layout-item.pl-0:first-child {
    padding-left: 0 !important;
}
</style>
